// extracted by mini-css-extract-plugin
module.exports = {"card":"Product_card__2suAL"};